const BLANK = 'BLANK';
const EMPTY_STRING = '';

export function isVenueInUSOrCA(countryCode: string): boolean {
  if (!countryCode) {
    return false;
  }
  const domesticCountryCodes = ['US', 'CA'];
  return domesticCountryCodes.includes(countryCode);
}

export const getLocation = (city: string, state: string, country: string): string => {
  let location = EMPTY_STRING;
  const hasState = state && state !== EMPTY_STRING && state !== BLANK;
  const hasCountry = country && country !== EMPTY_STRING && country !== BLANK;

  if (city && hasState && isVenueInUSOrCA(country)) {
    location = `${city}, ${state}`;
  } else if (city && hasCountry) {
    location = `${city}, ${country}`;
  } else if (hasCountry) {
    location = country;
  } else if (city) {
    location = city;
  }
  return location;
};
